import { render, staticRenderFns } from "./ProductoAgregarStockModal.vue?vue&type=template&id=062a2a78&scoped=true&"
import script from "./ProductoAgregarStockModal.vue?vue&type=script&lang=js&"
export * from "./ProductoAgregarStockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062a2a78",
  null
  
)

export default component.exports